export default __webpack_public_path__ + "assets/front/scss/classification-browsing.ccfcfb3afadf75ed61552088d816109f.css";